import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const LazyPrivateContentModeBanner = () =>
  import(/* webpackChunkName: "4-feat-private-content-mode-banner" */ './PrivateContentModeBanner');

const LoadablePrivateContentModeBanner: ComponentType = lazyLoadOnRender({
  loader: LazyPrivateContentModeBanner,
});
LoadablePrivateContentModeBanner.displayName = 'PrivateContentModeBanner';

export default LoadablePrivateContentModeBanner;
